<!--最顶部的搜索与下面的导航-->
<template>
  <div class="bodyBox">
    <div class="btnTop">
      <img src="https://deiyustatic.oss-cn-beijing.aliyuncs.com/header/1.png" @click="tiaozhuan" class="logoImg2"/>
      <el-icon style="font-size: 1vw;color: #fff;" @click="goToCart">
        <ShoppingCart class="hoverBox1" />
      </el-icon>
      <div class="hoverBox" @click="goToCart">采购车</div>
      <div class="hoverBox" v-if="this.username" @click="tiaozhuan2">{{ username }}</div>
      <div class="hoverBox" v-else @click="toLogin()">登录</div>

      <!-- <div class="hoverBox">定位</div> -->
      <!-- <div class="hoverBox1" @click="tiaozhuan2">设置</div> -->
    </div>
    <div class="title1">
      <!-- 图片要改 -->
      <!-- <img
        src="https://deiyustatic.oss-cn-beijing.aliyuncs.com/header/logo.png"
        alt
        class="logoImg"
        @click="toHome"
      />-->
      <img :src="images" alt class="logoImg" @click="toHome" />

      <div v-if="isShowNav" class="nav">
        <div
          @click="goToWhere(item.id)"
          class="titleBox"
          :class="activeNum === item.id ? 'active' : ''"
          v-for="item in tabs"
          :key="item.id"
        >{{ item.title }}</div>
      </div>

      <div v-else class="icon">
        <div class="menu" @click="table = true"></div>
        <el-drawer class="drawer" v-model="table" direction="ttb" size="60%">
          <div>
            <div
              style="width:calc(100% - 24px);border-bottom:1px solid green;margin-bottom:1%;margin-left: 12px"
            >
              <img
                src="https://deiyustatic.oss-cn-beijing.aliyuncs.com/logo.0924f7f1.png"
                alt
                width="25%"
              />
            </div>
            <div
              @click="goToWhere(item.id)"
              class="navTit"
              :class="activeNum === item.id ? 'active' : ''"
              v-for="item in tabs"
              :key="item.id"
            >
              <div style="width: 300px;margin-left: 12px">{{ item.title }}</div>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ajax } from "@/api";
export default {
  computed: {
    ...mapState(["homePage", "activeNum"])
  },
  data() {
    return {
      tabs: [
        { title: "首页", id: 1 },
        { title: "种植直供", id: 2 },
        { title: "工厂直销", id: 3 },
        { title: "物流服务", id: 4 },
        { title: "供应链金融", id: 5 },
        { title: "平台政策", id: 6 },
        { title: "价格指数", id: 7 }
      ],
      select: "",
      input: "",
      isFixed: false,
      username: "",
      images:
        "https://deiyustatic.oss-cn-beijing.aliyuncs.com/logo.0924f7f1.png",
      isShowNav: true,
      width: window.innerWidth,

      table: false,
      dialog: false,
      loading: false
    };
  },
  methods: {
    // 点击跳转  大屏
    tiaozhuan() {
      window.open("http://honghulianou.net/cloud", "_blank");
    },
    // 跳转后端
    tiaozhuan2() {
      //
      window.location.href = "http://honghulianou.net/memeber";
      //window.location.href = 'http://lianouvuememeber.cpolar.top';
    },
    goToWhere(index) {
      this.$store.commit("changeHeaderActive", index);
      if (index === 1) {
        // 首页
        this.$router.push("/home");
      } else if (index === 2) {
        // 种植基地
        this.$router.push("/planBase");
      } else if (index === 3) {
        // 工厂直销
        this.$router.push("/prefPro");
      } else if (index === 4) {
        // 物流服务
        this.$router.push("/platSup");
      } else if (index === 5) {
        // 供应链金融
        this.$router.push("/supSer");
      } else if (index === 6) {
        // 平台政策
        this.$router.push("/policy");
      } else if (index === 7) {
        // 价格指数
        this.$router.push("/price");
      } else if (index === 10) {
        // 登录
        this.$router.push("/login");
        sessionStorage.removeItem("username", this.username);
      }
    },
    toHome() {
      this.$router.push("/home");
    },

    toLogin() {
      this.$store.commit("changeHeaderActive", 1);
      this.$router.push("/login");
      sessionStorage.removeItem("username", this.username);
    },

    //获取屏幕宽度
    getWidth() {
      this.width = window.innerWidth;
      if (this.width < 599) {
        this.isShowNav = false;
      } else {
        this.isShowNav = true;
      }
      sessionStorage.removeItem("username", this.username);
    },
    goToCart() {
      this.$router.push("/shopping");
    },
    async getUser() {
      const res = await ajax.reUser();
      this.username = res.name;
    }
  },
  mounted() {
    this.activeIndex = 1;
    this.getWidth();
    window.addEventListener("resize", this.getWidth); // 添加事件监听器
    if (localStorage.getItem("token")) {
      this.getUser();
    }
  },
  created() {
    this.username = sessionStorage.getItem("username", this.username);
    this.getWidth();
  }
};
</script>

<style lang="less" scoped>
.bodyBox {
  position: fixed;
  z-index: 1000;
  width: 100%;
  // min-height: 10vh;
  background: #fff;
}

.active {
  color: rgba(0, 165, 79, 1);
}

.title1 {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .nav {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 1vw;
    font-weight: 800;
    height: 10vh;
  }
}

.titleBox {
  &:hover {
    color: rgba(0, 165, 79, 1);
    cursor: pointer;
  }
}

.logoImg {
  width: 11vw;
  margin-left: 1vw;
}

.btnTop {
  display: flex;
  justify-content: right;
  height: 2.2vh;
  background: rgba(61, 61, 61, 1);
  color: #fff;
  padding-right: 1vw;
  padding: 0.7vh 0.5vw;
  align-items: center;
  box-sizing: border-box;
  font-size: 0.8vw;
}

.logoImg2 {
  width: 4vw;
  height: 2vh;
  margin-right: 20px;
  cursor: pointer;
}

.hoverBox {
  // width: 4vw;
  padding: 0px 1vw;
  text-align: center;
  border-right: 0.2vh solid #ccc;
  height: 1vh;
  line-height: 1vh;

  &:hover {
    color: aqua;
    cursor: pointer;
  }
}

.hoverBox1 {
  width: 4vw;
  text-align: center;
  height: 1vh;
  line-height: 1vh;

  &:hover {
    color: aqua;
    cursor: pointer;
  }
}

//小屏导航栏样式

.el-icon svg {
  height: 2em;
  width: 2em;
}

.icon {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 5vw;
  height: 100%;
}

@media screen and (max-width: 599px) {
  .bodyBox {
    position: fixed;
    z-index: 1000;
    width: 100%;
    // min-height: 10vh;
    background: #fff;
  }

  .active {
    padding: 2% 0;
    width: 100%;
    border-radius: 5px;
    color: white !important;
    background-color: rgba(0, 165, 79, 1);
  }

  .title1 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 9px;
    font-weight: 800;
    height: 55px;

    .icon {
      .menu {
        padding: 4px 0;
        width: 22px;
        height: 3px;
        background: #606266;
        background-clip: content-box; //背景颜色从内容区域开始绘制
        border-top: 3px solid #606266;
        border-bottom: 3px solid #606266;
      }

      .drawer {
        .navTit {
          margin-top: 8px;
          margin-left: 0;
          font-size: 18px;
          color: rgba(61, 61, 61, 1);
          font-weight: 600;

          &:nth-child(n) {
            margin-bottom: 1%;
          }
        }
      }
    }
  }

  .titleBox {
    &:hover {
      color: rgba(0, 165, 79, 1);
      cursor: pointer;
    }
  }

  .logoImg {
    width: 20vw;
    // margin-right: 10vw;
  }

  .btnTop {
    display: flex;
    justify-content: right;
    // height: 2.2vh;
    background: rgba(61, 61, 61, 1);
    color: #fff;
    // padding-right: 4vw;
    // padding: 0.7vh 0.5vw;
    align-items: center;
    box-sizing: border-box;
    font-size: 12px;
  }

  .logoImg2 {
    width: 19vw;
    // margin-right: 20px;
    cursor: pointer;
  }

  .hoverBox {
    padding: 0px 1vw;
    // width: 14vw;
    text-align: center;
    border-right: 0.2vh solid #ccc;

    &:hover {
      color: aqua;
      cursor: pointer;
    }
  }

  .hoverBox1 {
    width: 14vw;
    text-align: center;

    &:hover {
      color: aqua;
      cursor: pointer;
    }
  }
}
</style>